import { faThumbsUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MDBBtn, MDBCard, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter } from "mdb-react-ui-kit";
import React from "react";
import request from "../util/client";

export function ReviewModal() {
  const [show, setShow] = React.useState(false);
  const [noteId, setNoteId] = React.useState(0);
  const [replyTo, setReplyTo] = React.useState(null);
  const callback = React.useRef(null);
  const onReview = React.useRef(e => {
    e.stopPropagation();
    e.preventDefault();
    let fd = new FormData(e.target);
    fd.set('type', fd.get('reviewId') ? '2' : '1');
    request('note/review/submit', 'POST', fd).then(() => {
      callback.current && callback.current(fd);
      setShow(false);
      callback.current = null;
    });
  });
  React.useEffect(() => {
    const showReview = e => {
      e.stopPropagation();
      e.preventDefault();
      if (e.data.noteId) {
        setNoteId(e.data.noteId);
        setReplyTo(e.data.review || null);
        setShow(true);
        callback.current = e.data.callback || null;
      }
    };
    window.document.addEventListener('review', showReview);
    return () => {
      window.document.removeEventListener('review', showReview);
    };
  }, []);
  return (
    <MDBModal show={show} setShow={setShow} tabIndex='-1'>
      <MDBModalDialog centered>
        <MDBModalContent tag="form" onSubmit={onReview.current}>
          <MDBModalBody>
            <input type="hidden" name="noteId" value={noteId} />
            {replyTo ? (
              <>
                <input type="hidden" name="reviewId" value={replyTo.reviewId} />
                <blockquote className="note note-primary">
                  <span>{replyTo.nickname}{parseInt(replyTo.isAuthor) ? '(作者)' : ''}: {replyTo.content}</span>
                </blockquote>
              </>
            ) : null}
            <textarea name="content" className="form-control" required placeholder="请输入评论内容"></textarea>
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn type="button" color="secondary" onClick={() => setShow(false)}>取消</MDBBtn>
            <MDBBtn type="submit">提交</MDBBtn>
          </MDBModalFooter>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  );
}

export default function Review(props) {
  const [data, setData] = React.useState([]);
  const [page, setPage] = React.useState(1);
  const isEnd = React.useRef(false);
  const isLoading = React.useRef(false);
  const onLike = React.useRef((reviewId, e) => {
    e.stopPropagation();
    e.preventDefault();
    let b = e.target;
    while (b.tagName !== 'BUTTON') {
      b = b.parentElement;
    }
    let type, v = b.querySelector('span');
    if (b.classList.contains('liked')) {
      type = '0';
      b.classList.remove('liked');
      v.innerText = parseInt(v.innerText) - 1;
    } else {
      type = '1';
      b.classList.add('liked');
      v.innerText = parseInt(v.innerText) + 1;
    }
    request('note/review/like', 'POST', { reviewId, type });
  });
  const onDownload = React.useRef(e => {
    e.stopPropagation();
    e.preventDefault();
    window.document.dispatchEvent(new Event('download'));
  });
  const onReply = React.useRef((review, noteId, e) => {
    e.stopPropagation();
    e.preventDefault();
    let ev = new Event('review');
    ev.data = {
      review, noteId, callback: () => {
        window.document.dispatchEvent(new Event('reloadreview'));
      }
    };
    window.document.dispatchEvent(ev);
  });
  const doLoad = () => {
    request('note/review/list', 'POST', { noteId: props.note, pageNo: page }).then(response => {
      setData(response.data.content);
      if (response.data.totalPages <= page) {
        isEnd.current = true;
      }
      isLoading.current = false;
    });
  };
  React.useEffect(() => {
    if (props.note) {
      if (isLoading.current || isEnd.current) {
        return;
      }
      isLoading.current = true;
      doLoad();
      window.document.addEventListener('reloadreview', doLoad);
      return () => window.document.removeEventListener('reloadreview', doLoad);
    }
  }, [props.note, page]);
  return (
    <>
      <MDBCard className="review" tag="ul">
        {data.map((item) => (
          <li className="review-detail" key={'review-' + item.reviewId}>
            <div className="review-author">
              <span className="avatar">
                <img src={item.avatarUrl} width="32" height="32" alt="" />
              </span>
              <div className="info">
                <span className="nickname">{item.nickname}</span>
                <span className="date">{item.date}</span>
              </div>
              <div className="tools">
                <MDBBtn type="button" color="link" onClick={onReply.current.bind(null, item, item.noteId)}>回复</MDBBtn>
                <MDBBtn type="button" color="link" className={parseInt(item.isLikeReview) ? 'liked' : ''} onClick={onLike.current.bind(null, item.reviewId)}>
                  <FontAwesomeIcon icon={faThumbsUp} />
                  <span>{item.likeReviewCount}</span>
                </MDBBtn>
              </div>
            </div>
            <p className="content">{item.content}</p>
            {(item.subReviewList || []).length ? (
              <ul>{item.subReviewList.map(sub => (
                <li key={'review-' + sub.reviewId}>
                  <span>{sub.nickname}{parseInt(sub.isAuthor) ? '(作者)' : ''}: {sub.content}</span>
                </li>
              ))}</ul>
            ) : null}
          </li>
        ))}
        <li className="more">
          <MDBBtn type="button" outline onClick={onDownload.current}>查看更多评论</MDBBtn>
        </li>
      </MDBCard>
    </>
  );
}
